import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import BusinessHubSectionPage from "./BusinessHubSectionPage.js";
import { getRouteForActiveKey } from "../utils/businessHubRoutes.js";

function UserManagmentPage() {
  const location = useLocation();
  const legacyActiveKey = location.state?.active;

  if (legacyActiveKey && legacyActiveKey !== "C") {
    return <Navigate replace to={getRouteForActiveKey(legacyActiveKey)} />;
  }

  return <BusinessHubSectionPage activeKey="C" />;
}

export default UserManagmentPage;
